import * as React from 'react';
import ReactTooltip from 'react-tooltip';
import { ColorPicker, ColorPickerHorizontalPosition, ColorPickerVerticalPosition } from '../../../components/ColorPicker/ColorPicker';
import { memo } from 'react';

type ColorPickerOptionProps = {
    color: string;
    label: string;
    tooltip: string;
    tooltipId: string;
    onChange: (color: string) => void;
    onClose: () => void;
    horizontalPosition: ColorPickerHorizontalPosition;
    verticalPosition: ColorPickerVerticalPosition;
    className?: string;
    disableAlpha?: boolean;
    containerRef?;
}

export const ColorPickerOption = memo(({ className, color, label, onChange, onClose, tooltip, tooltipId, disableAlpha, horizontalPosition, verticalPosition, containerRef }: ColorPickerOptionProps) => {

    return <div className="text-chat-options_table_row">
        <div className={`text-chat-options_two-parts-holder ${className}`}>
            <span className="text-chat-options_label"
                data-place="bottom"
                data-multiline="true"
                data-effect="solid"
                data-offset="{'top': -20}"
                data-class="tutor-light-tooltip tutor-no-arrow-tooltip tutor-light-tooltip-240 text-chat-option-tooltip"
                data-for={tooltipId}
                data-tip={tooltip}>{label}</span>
            <ColorPicker
                disableAlpha={disableAlpha}
                color={color}
                horizontalPosition={horizontalPosition}
                onClose={onClose}
                onChange={onChange}
                containerRef={containerRef}
                verticalPosition={verticalPosition}
                isHex={true}
            />
            <ReactTooltip id={tooltipId} />
        </div>
    </div>;
})